export const LIST_BOOK_CATEGORY = 'LIST_BOOK_CATEGORY';
export const CREATE_BOOK_CATEGORY = 'CREATE_BOOK_CATEGORY';
export const SHOW_BOOK_CATEGORY = 'SHOW_BOOK_CATEGORY';
export const UPDATE_BOOK_CATEGORY = 'UPDATE_BOOK_CATEGORY';
export const DELETE_BOOK_CATEGORY = 'DELETE_BOOK_CATEGORY';
export const ADD_DELETE = 'ADD_DELETE';
export const CHECK_ALL = 'CHECK_ALL';